import { render, staticRenderFns } from "./sceneManagementForm.vue?vue&type=template&id=67c4924a"
import script from "./sceneManagementForm.vue?vue&type=script&lang=js"
export * from "./sceneManagementForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports